export default "__VITE_ASSET__BlkngW0w__"